import { StyleSheet, Platform } from 'react-native';

import { isIPhoneDeviceWithNotch } from '../../../../Utils/Platform';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  closeButtonContainerStyle: {
    position: 'absolute',
    right: 0,
    alignItems: 'flex-end',
    marginTop: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 45 : 31) : 15,
    marginHorizontal: 15,
    padding: 5,
    zIndex: 1,
  },
});
